import event, {EVENTS} from '../../lib/event';
import clickElement from "./click-element";
import focusElement from "./focus-element";
import {focusBlock} from "../highlight";

/**
 * 等待游戏结束。可以在程序中通过触发游戏扩展中的"finish status"积木来触发结束，改积木的状态值为goto的步骤名称，如果步骤不存在，默认进入下一步
 * @param {string} status 当有值时只有当游戏结束的状态与status一致才能成功返回。不传入表示可以是任意状态结束，并且会将返回状态作为name进行goto
 * @param {bool} expectRunStop 当代码运行结束时，是否返回。需要注意的是这个不适合forever循环逻辑的交互式程序，只要当前没有代码块处于运行状态就会触发，特别时交互式的程序，等待输入时就会触发
 * @returns {Promise<unknown>}
 */
export default function expectPlayFinish({status, expectRunStop}, mode, _index) {
    if (status == undefined) status = 'success';
    return new Promise((resolve, reject)=>{
        const clear = () => {
            event.off(EVENTS.GAME_FINISH, finishHandle);
            event.off(EVENTS.PROJECT_RUN_STOP, stopHandle);
            event.off(EVENTS.STEP_ABORT, onAbort);
            event.emit(EVENTS.CLEAR_COVER);
        }
        const wrapResolve = arg => {
            clear();
            resolve(arg);
        }
        const wrapReject = arg => {
            clear();
            reject(arg);
        }
        const finishHandle = _status=>{
            console.log("finish handle: " + _status);
            /*
            if (status === undefined || _status === status) {
                resolve(_status);
            }else {
                reject(_status);
            }*/
            if (status === undefined || status == _status) {
                setTimeout(() => { //让validator先执行
                    wrapResolve({goto: _status});
                }, 500);
            }
        }
        const stopHandle = ()=>{
            console.log("stop");
            setTimeout(() => { //让validator先执行
                wrapResolve();
            }, 500);
        }
        event.on(EVENTS.GAME_FINISH, finishHandle);
        if (expectRunStop) {
            event.once(EVENTS.PROJECT_RUN_STOP, stopHandle);
            focusBlock({source: document.querySelector('img[class^="stop-all_stop-all"]'), tips: "点击红钮结束程序，进入下一步", noAudio: true, noModal: true, forcePoint: 2}, mode, _index);
        }
        const onAbort = ()=>{
            wrapReject('Step Abort');
            if (window.vm) window.vm.stopAll(); //自动停止游戏
        };
        event.once(EVENTS.STEP_ABORT, onAbort);
    });
}
